export const DEFAULT_EMPTY_STATE_WELCOME = `Welcome to your AI-powered MindUP teaching assistant—I’m so glad you’re here! To better understand how the MindUP curriculum can help your students learn and grow, watch this 1-minute intro video:`;

export const EMPTY_STATE_WELCOME_MAX_LENGTH = 4000;
